import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="night-header">
        <div className="night-left">
          <div className="night-badge">EST. 2025</div>
          <div className="night-logo">
            NEO<span>CAFÉ</span>
          </div>
        </div>

        <nav className="night-nav">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/menu">Menu</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/reviews">Reviews</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>

        <div className="night-right">
          <span className="night-city">OPEN · NYC</span>

          {/* CHANGED BUTTON */}
          <button className="night-nav-toggle" onClick={() => setOpen(true)}>
            <span className="lines">
              <i></i>
              <i></i>
            </span>
            <span className="label">NAV</span>
          </button>
        </div>
      </header>

      {/* FULLSCREEN NAV */}
      <div className={`night-overlay ${open ? "open" : ""}`}>
        <div className="overlay-close" onClick={() => setOpen(false)}>✕</div>

        <div className="overlay-nav">
          <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/menu" onClick={() => setOpen(false)}>Menu</NavLink>
          <NavLink to="/gallery" onClick={() => setOpen(false)}>Gallery</NavLink>
          <NavLink to="/reviews" onClick={() => setOpen(false)}>Reviews</NavLink>
          <NavLink to="/faqs" onClick={() => setOpen(false)}>FAQs</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        </div>
      </div>
    </>
  );
};

export default Header;
